<template>
    <b-container fluid class="p-3">
        <b-row>
            <b-col cols="9">
                <h1><t articles.title /></h1>
                <b-button
                    v-b-modal.product-modal
                    @click="newProduct()">
                    <t articles.newProduct />
                </b-button>

                <b-button
                    class="ml-3"
                    v-b-modal.thickness-modal
                    @click="newThickness()">
                    <t articles.newThickness />
                </b-button>

                <b-button
                    class="ml-3"
                    v-b-modal.db-modal
                    @click="generateDb()">
                    <t articles.importexport />
                </b-button>

                <b-button
                    class="ml-3"
                    v-b-modal.category-modal
                    @click="newCategory()">
                    <t articles.newCategory />
                </b-button>

                 <b-button
                    class="ml-3"
                    v-b-modal.matter-modal
                    @click="newMatter()">
                    <t articles.newMatter />
                </b-button>

            </b-col>
            <b-col cols="3">
                <t articles.selectionMode />
                <b-form-checkbox
                    class="mb-2"
                    id="input-active"
                    v-model="selectMultiple"
                    switch
                    size="lg"
                    :value="true"
                    :unchecked-value="false"
                >
                    <t articles.selectMultiple v-if="selectMultiple" />
                    <t articles.selectUnique v-if="!selectMultiple" />
                </b-form-checkbox>
            </b-col>
            <b-modal
                id="product-modal"
                ref="product-modal"
                hide-header
                hide-footer
                v-if="form.product"
                >
                <b-form @submit="onSubmitProduct" @reset="onReset">
                    <b-form-group
                        id="psid-fieldset"
                        :label="$t('articles.psid') + ' (id_product)'"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="psid-input"
                            v-model="form.product.psid"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="img-fieldset"
                        :label="$t('articles.matter_id')"
                        label-for="matter_id-input"
                        >
                        <v-select :value="form.product.matter_id" :reduce="name => name.matter_id" @input="updateMatter" :options="matters" label="nom"></v-select>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.description')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.product.name['fr']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.descriptionEn')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.product.name['en']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.descriptionDe')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.product.name['de']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="img-fieldset"
                        :label="$t('articles.img')"
                        label-for="img-input"
                        >

                        <b-form-input
                            id="img-input"
                            v-model="form.product.img"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-checkbox
                            class="mb-2"
                            id="input-steelgoods"
                            v-model="form.product.steelgoods"
                            switch
                            size="lg"
                            :value="true"
                            :unchecked-value="false"
                        >
                            <t product.steelgoods.active v-if="form.product.steelgoods" />
                            <t product.steelgoods.inactive v-else />
                    </b-form-checkbox>

                    <b-button type="submit" variant="primary" class="mr-2"><t common.save/></b-button>
                    <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                </b-form>
            </b-modal>

            <b-modal
                id="thickness-modal"
                ref="thickness-modal"
                hide-header
                hide-footer
                v-if="form.thickness"
                >
                <b-form  @submit="onSubmitThickness" @reset="onReset">
                    <b-form-group
                        id="psid-fieldset"
                        :label="$t('articles.psid') + ' (id_attribute)'"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="psid-input"
                            v-model="form.thickness.psid"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="thickness-fieldset"
                        :label="$t('articles.thickness')"
                        label-for="thickness-input"
                        >

                        <b-form-input
                            id="thickness-input"
                            v-model="form.thickness.thickness"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-button type="submit" variant="primary" class="mr-2"><t common.save/></b-button>
                    <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                </b-form>
            </b-modal>

            <b-modal
                id="db-modal"
                ref="db-modal"
                hide-header
                hide-footer
                v-if="form"
                >
                <b-form  @submit="onSubmitDb" @reset="onReset">
                    <b-form-group
                        id="db-fieldset"
                        :label="$t('articles.db')"
                        label-for="db-input"
                        >

                        <b-form-textarea
                            id="db-input"
                            v-model="form.db"
                            rows="15"
                            required
                            >
                        </b-form-textarea>
                    </b-form-group>


                    <b-button type="submit" variant="primary" class="mr-2"><t common.save /></b-button>
                    <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                </b-form>
            </b-modal>

            <b-modal
                id="category-modal"
                ref="category-modal"
                hide-header
                hide-footer
                v-if="form.category"
                >
                <b-form @submit="onSubmitCategory" @reset="onReset">
                    <b-form-group
                        id="psid-fieldset"
                        :label="$t('articles.category.id')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="psid-input"
                            v-model="form.category.category_id"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.category.description')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.category.name['fr']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.category.descriptionEn')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.category.name['en']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.category.descriptionDe')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.category.name['de']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="primary" class="mr-2"><t common.save/></b-button>
                    <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                </b-form>
            </b-modal>

            <b-modal
                id="matter-modal"
                ref="matter-modal"
                hide-header
                hide-footer
                v-if="form.matter"
                >
                <b-form @submit="onSubmitMatter" @reset="onReset">
                    <b-form-group
                        id="psid-fieldset"
                        :label="$t('articles.matter.id')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="psid-input"
                            v-model="form.matter.matter_id"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                     <b-form-group
                        id="psid-fieldset"
                        :label="$t('articles.category.id')"
                        label-for="name-input"
                        >
                        <v-select :value="form.matter.category_id" label="nom" :reduce="name => name.category_id" :options="categories" @input="updateCategory"></v-select>                       
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.matter.description')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.matter.name['fr']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.matter.descriptionEn')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.matter.name['en']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>

                    <b-form-group
                        id="name-fieldset"
                        :label="$t('articles.matter.descriptionDe')"
                        label-for="name-input"
                        >

                        <b-form-input
                            id="name-input"
                            v-model="form.matter.name['de']"
                            required
                            >
                        </b-form-input>
                    </b-form-group>
                    <b-button type="submit" variant="primary" class="mr-2"><t common.save/></b-button>
                    <b-button type="reset" variant="danger"><t common.cancel /></b-button>
                </b-form>
            </b-modal>
        </b-row>
        <b-row>
            <b-col cols="9">
                <table class="articleTable">
                    <thead>
                        <tr>
                            <th colspan="2" >
                                <b-button
                                    @click="selectAll()"
                                    variant="light"
                                    class="selectAll">*
                                </b-button>
                            </th>
                            <th v-for="thickness in thicknesses"
                                v-bind:key="thickness.psid">
                                <b-button
                                    v-b-modal.thickness-modal
                                    @click="editThickness(thickness)"
                                    variant="light"
                                    class="editThickness"
                                    :class="thickness.psid == thicknessHover ? 'hover' : ''"
                                    >
                                    {{thickness.thickness}}
                                </b-button>

                                <b-button
                                    @click="selectWholeThickness(thickness)"
                                    variant="light"
                                    class="wholeThickness">
                                    <b-icon icon="chevron-down" />
                                </b-button>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            v-for="product in products"
                            v-bind:key="product.psid">
                            <td>
                                <b-button
                                    v-b-modal.product-modal
                                    @click="editProduct(product)"
                                    variant="light"
                                    class="editProduct">

                                    {{getCategoryName(product.matter_id)}} : {{getMatterName(product.matter_id)}} ⇢ {{product.name[language]}}
                                </b-button>
                            </td>
                            <td>
                                <b-button
                                    @click="selectWholeProduct(product)"
                                    variant="light"
                                    class="wholeProduct">
                                    <b-icon icon="chevron-right" />
                                </b-button>
                            </td>

                            <td v-for="thickness in thicknesses"
                                v-bind:key="thickness.psid">
                                <b-button
                                    @click="selectArticle(product, thickness)"
                                    :pressed="isSelected(product, thickness)"
                                    variant="light"
                                    class="articleCell">

                                    <div v-if="hasParams(product, thickness)"><b-icon icon="file-earmark" /></div>

                                </b-button>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <hr>
                <table class="categoryTable">
                    <tbody v-for="category in categories" v-bind:key="category.category_id">
                        <div><b-button variant="light" class="editProduct" @click="editCategory(category)" v-b-modal.category-modal>{{category.name[language]}}</b-button></div>
                        <tr v-for="matter in getMatter(category.category_id)" v-bind:key="matter.matter_id">
                            <b-button
                                @click="editMatter(matter)"
                                variant="light"
                                class="editProduct"
                                v-b-modal.matter-modal>
                                    {{matter.name[language]}}
                            </b-button>
                        </tr>
                    </tbody> 
                </table>
            </b-col>
            <b-col cols="3">
                <div v-if="selectedArticles.length > 0">
                    <h3 v-if="selectedArticles.length == 1">{{selectedArticles[0].product.name}} - {{selectedArticles[0].thickness.thickness}} mm</h3>
                    <h3 v-else><t articles.selectedarticles /> {{selectedArticles.length}}</h3>
                    <b-form @submit="onSubmitOption">
                        <b-form-group v-if="newOption"
                            id="fieldset-newOptionKey"
                            :label="$t('articles.newoption.key')"
                            label-for="input-newOptionKey"
                            >
                            <b-form-input
                                size="sm"
                                id="input-newOptionKey"
                                v-model="newOption.key"
                                >
                            </b-form-input>
                        </b-form-group>
                        <b-button v-else
                            size="sm"
                            @click="newOption = {key:'', value:''};">
                            <t articles.newoption />
                        </b-button>
                        <b-button v-if="selectMultiple"
                            class="ml-3"
                            size="sm"
                            @click="applyFirstCurrents()">
                            <t articles.applyall />
                        </b-button>
                    </b-form>
                    <b-form @submit="onSubmitOptions" @reset="onReset" class="mt-3">
                        <b-input-group
                            size="sm"
                            v-for="opt in newOptions"
                            v-bind:key="opt.key"
                            :prepend="opt.key"
                            class="mt-1">
                             <b-form-input
                                :id="'input-' + opt.key"
                                v-model="opt.value"
                                class="customPlaceholder"
                                :placeholder="currentPlaceholder(opt.key)"
                                >
                            </b-form-input>
                                <b-button size="sm" v-if="selectMultiple && currentOptions[opt.key] && currentOptions[opt.key].length > 0" @click="applyFirstCurrent(opt)"><b-icon icon="check" /></b-button>
                                <b-button size="sm" variant="outline-danger" @click="removeOption(opt)"><b-icon icon="trash" /></b-button>
                        </b-input-group>

                        <div v-if="newOptions.length == 0">
                            <t articles.no-options />
                        </div>

                        <b-button size="sm" type="submit" variant="primary" class="mr-2 mt-3"><t common.save /></b-button>
                        <b-button size="sm" type="reset" variant="danger" class="mr-2 mt-3"><t common.cancel /></b-button>
                    </b-form>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>

/* eslint-disable vue/no-unused-components */
import { BContainer, BButton, BIcon, BModal, BFormGroup, BRow, BCol, BFormTextarea, BFormInput, VBModal, BForm,
            BIconChevronDown, BIconChevronRight, BFormCheckbox, BInputGroup, BIconTrash, BIconCheck, BIconFileEarmark
 } from 'bootstrap-vue';
import { models } from 'feathers-vuex';
import vSelect from 'vue-select'
export default {
    components: { BContainer, BButton, BIcon, BModal, BFormGroup, BRow, BCol, BFormTextarea, BFormInput, BForm,
                    BIconChevronDown, BIconChevronRight, BFormCheckbox, BInputGroup, BIconTrash, BIconCheck, BIconFileEarmark, vSelect },
    directives: {'b-modal': VBModal },
    data() {
        return {
            selectedProduct: null,
            selectedThickness: null,
            selectedCategory: null,
            selectedMatter: null,
            products: [],
            thicknesses: [],
            cuttingparams: [],
            categories: [],
            matters: [],
            selectedArticles: [],
            form: null,
            thicknessHover: null,
            selectMultiple: false,
            currentOptions: {},
            newOptions: [],
            newOption: null,
            language: 'fr',
            form: {
                product : {
                    psid: '',
                    name : {
                        fr: '',
                        de: '',
                        en: ''
                    },
                    matter_id: '',
                    steelgoods: false
                },
                category:{
                    category_id: '',
                    name : {
                        fr: '',
                        de: '',
                        en: ''
                    },
                },
                matter:{
                    matter_id: '',
                    category_id: '',
                    name : {
                        fr: '',
                        de: '',
                        en: ''
                    },
                },
                thickness: {
                    psid: '',
                    thickness: '',
                }
            }
        }
    },
    async mounted() {
        this.language = navigator.language.substr(0,2).toLowerCase();
        await this.refreshProducts();
        await this.refreshCategories();
        await this.refreshMatters();
        await this.refreshThicknesses();
        await this.refreshCuttingParams();
    },
    methods: {
        getMatter(categoryId){
            return this.matters.filter(matter => {
                return matter.category_id == categoryId;
            });
        },
        getProduct(matterId){
            return this.products.filter(product => {
                return product.matter_id == matterId;
            });
        },
        getMatterName(matter_id){
            if(this.matters.find(t => t.matter_id == matter_id)){
                return this.matters.find(t => t.matter_id == matter_id).name[this.language];
            }
        },

        getCategoryName(matter_id){
            if(this.matters.find(t => t.matter_id == matter_id)){
                let matter = this.matters.find(t => t.matter_id == matter_id);
                if(typeof(this.categories[0]) != "undefined"){
                    return this.categories.find(t => t.category_id == matter.category_id).name[this.language];
                }
            }
        },

        hasParams(product, thickness) {
            return typeof this.cuttingparams.find(c => c.product == product.psid && c.thickness == thickness.psid) != 'undefined';
        },

        isSelected(product, thickness) {
            return typeof this.selectedArticles.find(c => c.product == product && c.thickness == thickness) != 'undefined';
        },

        selectArticle(product, thickness) {
            if (this.selectMultiple) {
                let index = this.selectedArticles.findIndex(c => c.product == product && c.thickness == thickness);
                if (index < 0) this.selectedArticles.push({product, thickness});
                else this.selectedArticles.splice(index, 1);
            } else {
                this.selectedArticles = [{product, thickness}];
            }

            this.refreshOptions();
        },

        refreshOptions() {
            this.currentOptions = {};
            this.newOptions = [];
            this.newOption = null;

            let keys = []

            this.selectedArticles.forEach(article => {
                let params = this.cuttingparams.find(c => c.product == article.product.psid && c.thickness == article.thickness.psid);
                if (!params) return;

                keys = keys.concat(Object.keys(params.cuttingOptions));
            });
            keys = keys.filter((item, pos) => keys.indexOf(item) === pos);

            keys.forEach(key => {
                let values = this.selectedArticles.map(article => {
                    let params = this.cuttingparams.find(c => c.product == article.product.psid && c.thickness == article.thickness.psid);
                    return params == null ? null : params.cuttingOptions[key];
                });
                this.currentOptions[key] = values.filter((item, pos) => values.indexOf(item) === pos);
                this.newOptions.push({key, value: ''});
            })

            this.newOptions.sort((a, b) => a.key.localeCompare(b.key));
        },

        currentPlaceholder(key) {
            let currentValues = this.currentOptions[key];
            if (!currentValues) return 'Vide';

            return currentValues.map(val => val == null ? 'Vide' : val.toString()).join(', ');
        },

        newProduct() {
            this.selectedProduct = null;

            this.form.product = {
                psid: '',
                name : {
                    fr: '',
                    de: '',
                    en: ''
                },
                matter_id: '',
                steelgoods: false
            };
        },

        editProduct(product) {
            this.selectedProduct = product;
            this.form.product = {
                psid: product.psid,
                name : {
                    fr: product.name['fr'],
                    de: product.name['de'],
                    en: product.name['en']
                },
                matter_id: product.matter_id,
                img: product.img,
                steelgoods: product.steelgoods
            };
        },

        editThickness(thickness) {
            this.selectedThickness = thickness;
            this.form.thickness = {
                psid: thickness.psid,
                thickness: thickness.thickness
            };
        },

        newThickness() {
            this.selectedThickness = null;

            this.form.thickness = {
                psid: '',
                thickness: '',
            };
        },

        newCategory() {
            this.selectedCategory = null;

            this.form.category = {
                category_id: '',
                name : {
                    fr: '',
                    de: '',
                    en: ''
                },
            };
        },

        editCategory(category){
            this.selectedCategory = category;
            this.form.category = {
                category_id: category.category_id,
                name : {
                    fr: category.name['fr'],
                    de: category.name['de'],
                    en: category.name['en']
                },
            };
        },

        newMatter() {
            this.selectedMatter = null;

            this.form.matter = {
                matter_id: '',
                category_id: '',
                name : {
                    fr: '',
                    de: '',
                    en: ''
                },
            };
        },

        editMatter(matter){
            this.selectedMatter = matter;
            this.form.matter = {
                matter_id: matter.matter_id,
                category_id: matter.category_id,
                name : {
                    fr: matter.name['fr'],
                    de: matter.name['de'],
                    en: matter.name['en']
                },
            };
        },

        selectWholeThickness(thickness) {
            this.selectMultiple = true;
            let selectedProducts = this.selectedArticles
                .filter(article => article.thickness == thickness)
                .map(a => a.product.psid);

            let productsToSelect = this.cuttingparams
                .filter(param => param.thickness == thickness.psid)
                .filter(param => !selectedProducts.includes(param.product))
                .map(param => this.products.find(p => p.psid == param.product));

            if (productsToSelect.length > 0) {
                productsToSelect.forEach(product => {
                        this.selectedArticles.push({product, thickness})
                    }
                );
            } else {
                this.selectedArticles = this.selectedArticles.filter(a => a.thickness != thickness);
            }
            this.refreshOptions();
        },

        selectAll() {
            this.selectMultiple = true;
            this.selectedArticles = this.cuttingparams.map(param => {

                let product = this.products.find(p => p.psid == param.product);
                let thickness = this.thicknesses.find(t => t.psid == param.thickness);
                return { product, thickness};
            });
            this.refreshOptions();
        },

        selectWholeProduct(product) {
            this.selectMultiple = true;
            let selectedThicknesses = this.selectedArticles
                .filter(article => article.product == product)
                .map(a => a.thickness.psid);

            let thicknessesToSelect = this.cuttingparams
                .filter(param => param.product == product.psid)
                .filter(param => !selectedThicknesses.includes(param.thickness))
                .map(param => this.thicknesses.find(t => t.psid == param.thickness));

            if (thicknessesToSelect.length > 0) {
                thicknessesToSelect.forEach(thickness => {
                        this.selectedArticles.push({product, thickness})
                    }
                );
            } else {
                this.selectedArticles = this.selectedArticles.filter(a => a.product != product);
            }
            this.refreshOptions();
        },

        async refreshProducts() {
            let blockSize = 20;
            let response = await models.api.Product.find({query: {$limit: blockSize}});
            this.products = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Product.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.products = this.products.concat(response.data);
            }
            this.products.sort((a, b) => a.matter_id == b.matter_id ?  a.name[this.language].localeCompare(b.name[this.language]) : a.matter_id.localeCompare(b.matter_id));
        },

        async refreshThicknesses() {
            let blockSize = 50;
            let response = await models.api.Thickness.find({query: {$limit: blockSize}});
            this.thicknesses = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Thickness.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.thicknesses = this.thicknesses.concat(response.data);
            }
            this.thicknesses.sort((a, b) => a.thickness - b.thickness);
        },

        async refreshCuttingParams() {
            let blockSize = 20;
            let response = await models.api.CuttingParams.find({query: {$limit: blockSize}});
            this.cuttingparams = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.CuttingParams.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.cuttingparams = this.cuttingparams.concat(response.data);
            }

            this.refreshOptions();
        },

        async refreshCategories() {
            let blockSize = 20;
            let response = await models.api.Category.find({query: {$limit: blockSize}});
            this.categories = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Category.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.categories = this.categories.concat(response.data);
            }
            this.categories.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            this.categories.forEach(e => e.nom = e.name[this.language]);
        },

        async refreshMatters() {
            let blockSize = 20;
            let response = await models.api.Matter.find({query: {$limit: blockSize}});
            this.matters = response.data;
            let steps = response.total / blockSize;

            for (let i = 1; i < steps; i++) {
                response = await models.api.Matter.find({query: {$limit: blockSize, $skip: i * blockSize}});
                this.matters = this.matters.concat(response.data);
            }
            this.matters.sort((a, b) => a.name[this.language].localeCompare(b.name[this.language]));
            this.matters.forEach(e => e.nom = e.name[this.language]);
        },

        async onSubmitProduct(evt) {
            evt.preventDefault()
            try {
                if (this.selectedProduct == null) {
                    let product = new models.api.Product({
                        psid: this.form.product.psid,
                        name : {
                            fr: this.form.product.name['fr'],
                            de: this.form.product.name['de'],
                            en: this.form.product.name['en']
                        },
                        matter_id: this.form.product.matter_id,
                        img: this.form.product.img,
                        steelgoods: this.form.product.steelgoods
                    });
                    await product.create();
                } else {
                    this.selectedProduct.psid = this.form.product.psid;
                    this.selectedProduct.name = {
                        fr: this.form.product.name['fr'],
                        de: this.form.product.name['de'],
                        en: this.form.product.name['en']
                    },
                    this.selectedProduct.matter_id = this.form.product.matter_id;
                    this.selectedProduct.img = this.form.product.img;
                    this.selectedProduct.steelgoods = this.form.product.steelgoods;
                    await this.selectedProduct.save();
                }
                this.$refs['product-modal'].hide()
                await this.refreshProducts();
            } catch (err) {
                this.$bvToast.toast(err.message, {
                    variant: 'danger',
                    title: "Oh non...",
                    autoHideDelay: 800,
                    solid: true
                });
                console.error(err);
            }
        },

        async onSubmitThickness(evt) {
            evt.preventDefault()
            try {
                if (this.selectedThickness == null) {
                    let thickness = new models.api.Thickness({
                        psid: this.form.thickness.psid,
                        thickness: this.form.thickness.thickness
                    });
                    await thickness.create();
                } else {
                    this.selectedThickness.psid = this.form.thickness.psid;
                    this.selectedThickness.thickness = parseFloat(this.form.thickness.thickness);
                    await this.selectedThickness.save();
                }
                this.$refs['thickness-modal'].hide()
                await this.refreshThicknesses();
            } catch (err) {
                this.$bvToast.toast(err.message, {
                    variant: 'danger',
                    title: "Oh non...",
                    autoHideDelay: 800,
                    solid: true
                });
                console.error(err);
            }
        },

        async onSubmitCategory(evt) {
            evt.preventDefault()
            try {
                if (this.selectedCategory == null) {
                    let category = new models.api.Category({
                        category_id: this.form.category.category_id,
                        name : {
                            fr: this.form.category.name['fr'],
                            en: this.form.category.name['en'],
                            de: this.form.category.name['de']
                        },
                    });
                    await category.create();
                }else{
                    this.selectedCategory.category_id = this.form.category.category_id;
                    this.selectedCategory.name = {
                        fr: this.form.category.name['fr'],
                        de: this.form.category.name['de'],
                        en: this.form.category.name['en']
                    },
                    await this.selectedCategory.save();
                }
                this.$refs['category-modal'].hide()
                await this.refreshCategories();
            }catch(err){
                this.$bvToast.toast(err.message, {
                    variant: 'danger',
                    title: "Oh non...",
                    autoHideDelay: 800,
                    solid: true
                });
                console.error(err);
            }
        },

        async onSubmitMatter(evt) {
            evt.preventDefault()
            try {
                if (this.selectedMatter == null) {
                    let matter = new models.api.Matter({
                        matter_id: this.form.matter.matter_id,
                        category_id: this.form.matter.category_id,

                        name : {
                            fr: this.form.matter.name['fr'],
                            en: this.form.matter.name['en'],
                            de: this.form.matter.name['de']
                        },
                    });
                    await matter.create();
                }else{
                    this.selectedMatter.matter_id = this.form.matter.matter_id;
                    this.matter.category_id = this.form.matter.category_id;
                    this.matter.name = {
                        fr: this.form.matter.name['fr'],
                        de: this.form.matter.name['de'],
                        en: this.form.matter.name['en']
                    },
                    await this.selectedMatter.save();
                }
                this.$refs['matter-modal'].hide()
                await this.refreshMatters();
            }catch(err){
                this.$bvToast.toast(err.message, {
                    variant: 'danger',
                    title: "Oh non...",
                    autoHideDelay: 800,
                    solid: true
                });
                console.error(err);
            }
        },

        updateMatter(value){
            this.form.product.matter_id = value;
        },

        updateCategory(value){
            this.form.matter.category_id = value;
        },

        onSubmitOption(evt) {
            evt.preventDefault();
            if (this.newOption.key == '') return;

            let existing = this.newOptions.find(o => o.key == this.newOption.key);
            if (existing) existing.value = this.newOption.value;
            else this.newOptions.push(this.newOption);
            this.newOption = null;
        },

        removeOption(option) {
            let index = this.newOptions.findIndex(o => o.key == option.key);
            if (index >= 0) this.newOptions.splice(index, 1);
        },

        applyFirstCurrent(option) {
            let opt = this.newOptions.find(o => o.key == option.key);
            let currentOption = this.currentOptions[option.key];
            if (opt && currentOption && currentOption.length > 0) opt.value = currentOption[0] == null ? currentOption[1] : currentOption[0];
        },

        applyFirstCurrents() {
            this.newOptions.forEach(opt => {
                let currentOption = this.currentOptions[opt.key];
                if (opt && currentOption && currentOption.length > 0) opt.value = currentOption[0] == null ? currentOption[1] : currentOption[0];
            })
        },

        async onSubmitOptions(evt) {
            evt.preventDefault()
            try {
                if (this.newOptions.length == 0) {
                    this.removeSelectedParams();
                    return;
                }
                let cuttingOptions = {};
                this.newOptions
                    .filter(option => option.value != '')
                    .forEach(option => cuttingOptions[option.key] = parseFloat(option.value));

                for (let i = 0; i < this.selectedArticles.length; i++) {
                    let article = this.selectedArticles[i];
                    let params = this.cuttingparams.find(c => c.product == article.product.psid && c.thickness == article.thickness.psid);

                    if (!params) {
                        params = new models.api.CuttingParams({
                            product: article.product.psid,
                            thickness: article.thickness.psid,
                            cuttingOptions
                        });
                        await params.create();
                    } else {
                        let articleCuttingOptions = {...cuttingOptions};

                        for (let [key, previousValue] of Object.entries(params.cuttingOptions)) {
                            let option = this.newOptions.find(o => o.key == key);
                            if (option && option.value == '') {
                                articleCuttingOptions[key] = previousValue;
                            }
                        }
                        params.cuttingOptions = articleCuttingOptions;
                        await params.save();
                    }
                }

                this.$bvToast.toast(this.$t('articles.saveoptions.body'), {
                    variant: 'success',
                    title: this.$t('common.success'),
                    autoHideDelay: 800,
                    solid: true
                })


            } catch (err) {
                this.$bvToast.toast(err.message, {
                    variant: 'danger',
                    title: this.$t('common.error'),
                    autoHideDelay: 800,
                    solid: true
                });
                console.error(err);
            }
            await this.refreshCuttingParams();
        },

        async removeSelectedParams() {
            for (let i = 0; i < this.selectedArticles.length; i++) {
                let article = this.selectedArticles[i];
                let params = this.cuttingparams.find(c => c.product == article.product.psid && c.thickness == article.thickness.psid);

                if (params) await params.remove();
            }
            await this.refreshCuttingParams();
        },

        async onReset(evt) {
            evt.preventDefault();
            await this.$refs['product-modal'].hide();
            await this.$refs['thickness-modal'].hide();
            await this.$refs['db-modal'].hide();
            await this.$refs['category-modal'].hide();
            await this.$refs['matter-modal'].hide();
        },

        generateDb() {

            let products = [...this.products],
                thicknesses = [...this.thicknesses],
                cuttingparams =  [...this.cuttingparams];

            products.forEach(p => delete p._id);
            thicknesses.forEach(t => delete t._id);
            cuttingparams.forEach(cp => delete cp._id);

            this.form = {
                db: JSON.stringify({
                    products,
                    thicknesses,
                    cuttingparams
                })
            };
        },

        async onSubmitDb(evt) {
            evt.preventDefault();

            let newDb = JSON.parse(this.form.db);

            await this.updateProducts(newDb.products);
            await this.updateThicknesses(newDb.thicknesses);
            await this.updateCuttingParams(newDb.cuttingparams);

            await this.$refs['db-modal'].hide();
        },

        async updateProducts(newProducts) {
            let existingPsids = this.products.map(p => p.psid);
            let newPsids = [];

            let nbCreated = 0, nbUpdated = 0, nbRemoved = 0;

            newProducts.forEach(newProduct => {
                newPsids.push(newProduct.psid);
                if (existingPsids.indexOf(newProduct.psid) >= 0) {
                    nbUpdated++;// update
                } else {
                    nbCreated++;
                    // create
                }
            })

            let removed = this.products.filter(p => newPsids.indexOf(p.psid) < 0);
            nbRemoved = removed.length;

            this.$bvToast.toast("Ajouts : " + nbCreated + ", modifications : " + nbUpdated + ", suppressions : " + nbRemoved, {
                variant: 'info',
                title: "Produits",
                autoHideDelay: 2000,
                solid: true
            });
        },

        async updateThicknesses(newThicknesses) {
            let existingPsids = this.thicknesses.map(t => t.psid);
            let newPsids = [];

            let nbCreated = 0, nbUpdated = 0, nbRemoved = 0;

            newThicknesses.forEach(newThicknesse => {
                newPsids.push(newThicknesse.psid);
                if (existingPsids.indexOf(newThicknesse.psid) >= 0) {
                    nbUpdated++;// update
                } else {
                    nbCreated++;
                    // create
                }
            })

            let removed = this.thicknesses.filter(t => newPsids.indexOf(t.psid) < 0);
            nbRemoved = removed.length;

            this.$bvToast.toast("Ajouts : " + nbCreated + ", modifications : " + nbUpdated + ", suppressions : " + nbRemoved, {
                variant: 'info',
                title: "Epaisseurs",
                autoHideDelay: 2000,
                solid: true
            });
        },

        async updateCuttingParams(newCuttingParams) {
            let existingPsids = this.cuttingparams.map(cp => cp.product + ':' + cp.thickness);
            let newPsids = [];

            let nbCreated = 0, nbUpdated = 0, nbRemoved = 0;

            newCuttingParams.forEach(newCuttingParam => {
                let psid = newCuttingParam.product + ':' + newCuttingParam.thickness;
                newPsids.push(psid);
                if (existingPsids.indexOf(psid) >= 0) {
                    nbUpdated++;// update
                } else {
                    nbCreated++;
                    // create
                }
            })

            let removed = this.cuttingparams.filter(cp => newPsids.indexOf(cp.product + ':' + cp.thickness) < 0);
            nbRemoved = removed.length;

            this.$bvToast.toast("Ajouts : " + nbCreated + ", modifications : " + nbUpdated + ", suppressions : " + nbRemoved, {
                variant: 'info',
                title: "Options de découpe",
                autoHideDelay: 2000,
                solid: true
            });
        }
    }
}
</script>

<style lang="scss" scoped>
    .articleTable, .categoryTable{
        height: 80vh;
        display: block;
        overflow: auto;

        th {
            position: -webkit-sticky;
            position: sticky;
            top: 0;
            background: white;
            padding: 0 0 1px 1px;
            box-shadow: 0px 1px 0px 0px #777;
            width: 2rem;
        }

        tbody {
            td {
                height: 2rem;
            }
        }
        .editThickness {
            font-size: 90%;
            padding: 0.2rem 0.1rem;
            width: 2rem;
        }
        .wholeThickness {
            text-align: center;
            padding: 0.2rem 0;
            width: 2rem;
            font-size: 70%;
        }
        .editProduct{
            width: 100%;
            font-size: 90%;
            text-align: left;
        }
        .wholeProduct {
            padding: 0 0.1rem;
            height: 100%;
            font-size: 70%;
        }
        .articleCell {
            padding: 0 0.1rem;
            height: 100%;
            width: 2rem;
            font-size: 70%;
        }

        .selectAll {
            float: right;
            font-size: 90%;
            width: 2em;
            height: 2em;
            margin-top: 1em;
            margin-right: 0.5em;
            margin-bottom: 0em;
            text-align: center;
        }

        tr:hover .editProduct,
        .editThickness.hover
        {
            border: 1px solid orange;
        }
    }

    .customPlaceholder::placeholder {
        color: #bbb;
    }

    .categoryTable tr button{
        margin-left: 1vw;
    }

</style>
